(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blendr-b2b"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('blendr-b2b-page');
    if (!root) return;

    const modelDetails = root.querySelectorAll('.br-b2b__model');

    modelDetails.forEach((detail) => {
      const summary = detail.querySelector(':scope > summary');
      if (!summary) return;

      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');

      detail.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;

        const target = document.querySelector(targetId);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'start'
        });
      });
    });

    const status = document.getElementById('b2b-form-status');
    if (status) {
      status.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
